import { cn } from '@/lib/utils'
import { Badge } from '@/components/ui/badge'
import type { LeadSource } from '@limo/shared'
import {
  Globe,
  Phone,
  Mail,
  Users,
  MapPin,
  Megaphone,
  MoreHorizontal,
} from 'lucide-react'

interface LeadSourceBadgeProps {
  source: LeadSource
  sourceDetail?: string | null
  showIcon?: boolean
  className?: string
}

const SOURCE_CONFIG: Record<
  LeadSource,
  { label: string; icon: typeof Globe; className: string }
> = {
  website: {
    label: 'Website',
    icon: Globe,
    className: 'bg-blue-50 text-blue-700 border-blue-200',
  },
  phone: {
    label: 'Phone',
    icon: Phone,
    className: 'bg-green-50 text-green-700 border-green-200',
  },
  email: {
    label: 'Email',
    icon: Mail,
    className: 'bg-purple-50 text-purple-700 border-purple-200',
  },
  referral: {
    label: 'Referral',
    icon: Users,
    className: 'bg-amber-50 text-amber-700 border-amber-200',
  },
  walk_in: {
    label: 'Walk-in',
    icon: MapPin,
    className: 'bg-teal-50 text-teal-700 border-teal-200',
  },
  advertising: {
    label: 'Advertising',
    icon: Megaphone,
    className: 'bg-pink-50 text-pink-700 border-pink-200',
  },
  other: {
    label: 'Other',
    icon: MoreHorizontal,
    className: 'bg-gray-50 text-gray-700 border-gray-200',
  },
}

export function LeadSourceBadge({
  source,
  sourceDetail,
  showIcon = true,
  className,
}: LeadSourceBadgeProps) {
  const config = SOURCE_CONFIG[source] || SOURCE_CONFIG.other
  const Icon = config.icon

  return (
    <Badge
      variant="outline"
      className={cn(
        'font-normal border',
        config.className,
        className
      )}
      title={sourceDetail || undefined}
    >
      {showIcon && <Icon className="mr-1 h-3 w-3" aria-hidden="true" />}
      <span>{config.label}</span>
    </Badge>
  )
}
